export default "__VITE_ASSET__f5dafb06__"